import { Component, OnInit, ViewChild } from '@angular/core';
import { seeds } from '../../seeds/seeds';
import { NgForm } from '@angular/forms';
import { QueryService } from '../query.service';
import { Query } from '../query.model';

@Component({
  selector: 'app-haulers-query',
  templateUrl: './haulers-query.component.html',
  styleUrls: ['./haulers-query.component.css']
})

export class HaulersQueryComponent implements OnInit {
  wasteTypes = seeds.wasteTypes;
  items: string[] = []

  @ViewChild('f') clForm: NgForm;

  constructor(private queryService: QueryService) { }

  ngOnInit() {
    this.clForm.value.services = { collect : true, treatment : true};
  }

  onSubmit(form: NgForm) {
    console.log(form.value);
    if (form.value.wastes === '') { form.value.wastes = []; }
    // const wastes = form.value['wastes'].map(waste => waste.value);
    const query: Query = new Query(form.value.location, form.value.radius * 1000, form.value.services, form.value.wastes);
    this.queryService.updateQuery(query);
  }

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-query/haulers-query.component.ts